export const mailToLink = (to: string, subject?: string, body?: string): string => {
  const args: string[] = [];
  if (subject !== undefined) {
    args.push('subject=' + encodeURIComponent(subject));
  }
  if (body !== undefined) {
    args.push('body=' + encodeURIComponent(body));
  }
  return `mailto:${encodeURIComponent(to)}${args.length > 0 ? '?' + args.join('&') : ''}`;
};
